import { useState } from "react";
import PageHeader from "../../components/PageHeader";
import ProjectList from "../../components/ProjectList";
import CallToAction from "../../components/CallToAction";
import projects from "../../_data/projects.json";

const filters = [
  { key: "all", label: "All" },
  { key: "mobile", label: "Mobile apps" },
  { key: "web", label: "Web" },
  { key: "ai", label: "AI" },
];

/**
 * Represents the Portfolio page component.
 * Displays a filterable list of projects.
 *
 * @component
 */

const Portfolio = () => {
  const [filter, setFilter] = useState("all");
  const visible = filter === "all" ? projects : projects.filter((p) => p.category.includes(filter));

  return (
    <>
      <main className="portfolio container">
        <PageHeader title="Portfolio" description="View my work" />
        <p className="pageLead">
          iOS &amp; Android apps, web platforms, CMS and admin panels I've designed, built and shipped — with React
          Native, React, Next.js and Node.js.
        </p>

        <div className="filterTabs" role="group" aria-label="Filter projects">
          {filters.map((f) => (
            <button
              key={f.key}
              type="button"
              className={filter === f.key ? "active" : ""}
              aria-pressed={filter === f.key}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
              <span>{f.key === "all" ? projects.length : projects.filter((p) => p.category.includes(f.key)).length}</span>
            </button>
          ))}
        </div>

        <div className="row" key={filter}>
          <ProjectList projects={visible} />
        </div>
      </main>
      <CallToAction title="Want a product like these? Let's talk." />
    </>
  );
};

export default Portfolio;
